import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const CheckThin = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7107 3.33334L5.84333 11.0667L2.15866 7.42L1.22133 8.368L5.37266 12.4773C5.49743 12.6005 5.66568 12.6695 5.841 12.6695C6.01631 12.6695 6.18456 12.6005 6.30933 12.4773L14.6427 4.28267L13.7107 3.33334Z"
      fill="currentColor"
    />
  </svg>,
  'CheckThin'
);
